/**
 * 예외 → 사용자에게 보여줄 한 줄 문구.
 *
 * apiFetch(@shared/api/api)는 catch 블록 안에서 error.message를 JSON.parse 하는데,
 * 네트워크 단절이면 message가 "Failed to fetch"라서 그 JSON.parse가 SyntaxError를
 * 던지고, 그게 호출자까지 그대로 올라온다. 이걸 걸러내지 않으면 챗봇 말풍선이나
 * 안내 배너에 `Unexpected token 'F', "Failed to fetch" is not valid JSON`이 노출된다.
 */
export function describeError(
  e: unknown,
  fallback = "요청 처리 중 오류가 발생했습니다."
): string {
  const NETWORK = "서버에 연결하지 못했습니다. 네트워크 상태를 확인해 주세요.";

  // apiFetch 내부 JSON.parse가 터진 경우 = 원인이 네트워크/비JSON 응답
  if (e instanceof SyntaxError) return NETWORK;

  const raw = (e as any)?.message;
  if (typeof raw !== "string" || !raw.trim()) return fallback;
  const msg = raw.trim();

  if (/^(Failed to fetch|NetworkError|Load failed)/i.test(msg)) return NETWORK;

  // 서버 응답 JSON이 message에 통째로 실려온 경우 message 필드만 꺼내 쓴다
  if (msg.startsWith("{")) {
    try {
      const parsed = JSON.parse(msg);
      const inner = parsed?.message;
      if (typeof inner === "string" && inner.trim()) return inner.trim();
    } catch {
      /* 파싱 실패 시 원문을 그대로 노출하지 않는다 */
    }
    return fallback;
  }

  return msg;
}
